import { Target, Eye } from 'lucide-react';
import { Reveal, SectionHeading } from './Reveal';
import { useLang } from '../i18n';

export default function MissionVision() {
    const { t } = useLang();
    return (
        <section className="relative py-24 lg:py-32" style={{ background: 'linear-gradient(135deg, #E2F1F8 0%, #FFF8E7 55%, #FCE7F0 100%)' }} data-testid="mision-vision-section">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <SectionHeading eyebrow={t('mv_eyebrow')} title={t('mv_title')} />

                <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8 mt-14">
                    <Reveal className="lg:col-span-7">
                        <article
                            className="h-full rounded-[1.6rem] bg-ink text-pastelcream p-9 lg:p-12 relative overflow-hidden group"
                            data-testid="mision-card"
                        >
                            <div className="absolute -right-10 -top-10 w-56 h-56 rounded-full bg-crimson/20 blur-3xl transition-opacity group-hover:opacity-80" />
                            <Target size={34} className="text-pastelcream/90" strokeWidth={1.5} />
                            <p className="font-ink text-[11px] uppercase tracking-[0.3em] text-pastelcream/60 mt-8">
                                {t('mv_mision_t')}
                            </p>
                            <p className="font-display text-2xl lg:text-[2rem] leading-snug mt-4 font-medium">
                                {t('mv_mision_main')}
                            </p>
                            <p className="mt-5 text-pastelcream/70 leading-relaxed max-w-lg">
                                {t('mv_mision_sub')}
                            </p>
                        </article>
                    </Reveal>

                    <Reveal className="lg:col-span-5" delay={0.12}>
                        <article
                            className="h-full rounded-[1.6rem] bg-white border border-ink/10 p-9 lg:p-12 relative overflow-hidden"
                            data-testid="vision-card"
                        >
                            <Eye size={34} className="text-crimson" strokeWidth={1.5} />
                            <p className="font-ink text-[11px] uppercase tracking-[0.3em] text-ink/50 mt-8">
                                {t('mv_vision_t')}
                            </p>
                            <p className="font-display text-2xl lg:text-[2rem] leading-snug mt-4 font-medium text-ink">
                                {t('mv_vision_main')}
                            </p>
                            <p className="mt-5 text-ink/70 leading-relaxed">
                                {t('mv_vision_sub')}
                            </p>
                        </article>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
